<template>
  <div class="app" >
    <!-- <navigationnew v-if="copyright"></navigationnew> -->
    <navigation v-if="copyright"></navigation>
    <router-view v-if="ifNew" class="router-box" :key="$route.fullPath" />
    <footer class="footer">
      <footers v-if="copyright"></footers>
    </footer>
  </div>
</template>
<script>
// import navigation from "@/components/navigation";
import navigationnew from "@/components/navigationnew";
import footers from "@/components/footers";
import navigation from "@/components/navigation";

import { getDomain, setDomain, setDomainToken } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    navigation,
    navigationnew,
    footers
  },
  data() {
    return {
      copyright: '',
      ifNew: false,
    };
  },
  async created() {
      this.copyright = getDomain();
      console.log(this.copyright,'copyright');
      
      const dnsApiCalled = localStorage.getItem('dnsApiCalled');
      if (!this.copyright && !dnsApiCalled) {
        await homeClient.getDnsOneApi().then((res) => {
          if (res.code == 0) {
            setDomainToken(res.data.domainToken) 
            setDomain(res.data.entrants)
            localStorage.setItem('isXiaoQingWang', res.data.xiaoQingId)
            this.copyright = res.data.entrants;
          }
          localStorage.setItem('dnsApiCalled', 'true');
          this.ifNew = true;
        });
      } else {
        this.ifNew = true;
      }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    }
  },
};
</script>
<style lang="less" scoped>
.app {
  width: 100%;
  // height: 100%;
  min-height: 100vh;
  position: relative;
}
</style>
